var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-opt-dialog"},_vm._l((_vm.nodeList),function(i){return _c('el-button',{key:i.id,attrs:{"type":i.id == _vm.btnId ? 'primary' : ''},on:{"click":function($event){return _vm.changeFloor(i)}}},[_vm._v(_vm._s(i.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }